<div class="step-four">
  <div class="step-four__layout">
    <div class="step-four__back">
      <ds-button-v2
        emphasis="terciary"
        size="xs"
        leadingIcon="ArrowBack"
        [label]="stepFour.back"
        (clicked)="goToPreviousStep()"
      ></ds-button-v2>
    </div>

    <div class="step-four__columns">
      <div class="step-four__primary">
        <div class="step-four__heading">
          <p class="step-four__flow">{{ stepFour.flowName }}</p>
          <div class="step-four__heading-text">
            <h2 class="step-four__title">{{ stepFour.title }}</h2>
            <p class="step-four__subtitle">{{ stepFour.subtitle }}</p>
          </div>
        </div>

        <ds-card shadow="l2">
          <section class="step-four__card">
            <div class="step-four__sections">
              <div class="step-four__section">
                <h3 class="step-four__section-title">{{ stepFour.savingTitle }}</h3>
                <div class="step-four__amount-row">
                  <p class="step-four__amount">{{ savingAmount }}</p>
                  <div class="step-four__edit">
                    <ds-button-v2
                      emphasis="secondary-outlined"
                      size="s"
                      [fullWidth]="true"
                      maxWidth="100%"
                      [label]="stepFour.editButton"
                      (clicked)="editStep(1)"
                    ></ds-button-v2>
                  </div>
                </div>
              </div>

              <div class="step-four__section">
                <h3 class="step-four__section-title">{{ stepFour.regimeTitle }}</h3>
                <dl class="step-four__data">
                  <div *ngFor="let detail of regimeDetails" class="step-four__data-item">
                    <dt class="step-four__data-label">{{ detail.label }}</dt>
                    <dd class="step-four__data-value">{{ detail.value }}</dd>
                  </div>
                </dl>
                <div class="step-four__edit">
                  <ds-button-v2
                    emphasis="secondary-outlined"
                    size="s"
                    [fullWidth]="true"
                    maxWidth="100%"
                    [label]="stepFour.editButton"
                    (clicked)="editStep(2)"
                  ></ds-button-v2>
                </div>
              </div>

              <div class="step-four__section">
                <h3 class="step-four__section-title">{{ stepFour.employerTitle }}</h3>
                <dl class="step-four__data">
                  <div *ngFor="let detail of employerDetails" class="step-four__data-item">
                    <dt class="step-four__data-label">{{ detail.label }}</dt>
                    <dd class="step-four__data-value">{{ detail.value }}</dd>
                  </div>
                </dl>
                <div class="step-four__edit">
                  <ds-button-v2
                    emphasis="secondary-outlined"
                    size="s"
                    [fullWidth]="true"
                    maxWidth="100%"
                    [label]="stepFour.editButton"
                    (clicked)="editStep(3)"
                  ></ds-button-v2>
                </div>
              </div>

              <div class="step-four__section">
                <h3 class="step-four__section-title">{{ stepFour.userTitle }}</h3>
                <dl class="step-four__data">
                  <div *ngFor="let detail of userDetails" class="step-four__data-item">
                    <dt class="step-four__data-label">{{ detail.label }}</dt>
                    <dd class="step-four__data-value">{{ detail.value }}</dd>
                  </div>
                </dl>
              </div>

              <div class="step-four__section">
                <h3 class="step-four__section-title">{{ stepFour.executiveTitle }}</h3>
                <div class="step-four__field">
                  <p class="step-four__field-label">{{ stepFour.executiveLabel }}</p>
                  <ds-input-text
                    visualTransformation="rut"
                    [maxCharacters]="9"
                    [showMaxCharacters]="false"
                    [placeholder]="stepFour.executivePlaceholder"
                    [value]="executiveRutValue"
                    [state]="isExecutiveRutInvalid ? 'error' : 'default'"
                    [helpText]="stepFour.executiveError"
                    [showHelpText]="isExecutiveRutInvalid"
                    (valueChange)="onExecutiveRutChange($event)"
                    (blurred)="onExecutiveRutBlur()"
                  ></ds-input-text>
                </div>
              </div>
            </div>
          </section>
        </ds-card>

        <ds-card shadow="l2">
          <section class="step-four__accept">
            <ds-check
              class="step-four__accept-check"
              [checked]="isSubscriptionAccepted"
              [ariaLabel]="stepFour.acceptText"
              (checkedChange)="setAcceptance($event)"
            ></ds-check>
            <p class="step-four__accept-text" (click)="setAcceptance(!isSubscriptionAccepted)">
              {{ stepFour.acceptText }}
            </p>
          </section>
        </ds-card>

        <div class="step-four__submit">
          <div class="step-four__submit-action">
            <ds-button-v2
              emphasis="primary"
              size="m"
              [fullWidth]="true"
              maxWidth="100%"
              [disabled]="!canSubscribe || showSpinner"
              [label]="stepFour.submitButton"
              (clicked)="submitSubscribtionApv()"
            ></ds-button-v2>
          </div>
        </div>
      </div>

      <app-stepper-lateral
        class="step-four__stepper"
        [currentStep]="currentStepIndex"
      ></app-stepper-lateral>
    </div>
  </div>
</div>
